const columnsRx = [
  {
    title: 'Ojo',
    dataIndex: 'ojo',
    key: 'ojo',
    className: 'borderedColumn',
  },
  {
    title: 'Eje',
    dataIndex: 'eje',
    key: 'eje',
  },
  {
    title: 'Cilindro',
    dataIndex: 'cilindro',
    key: 'cilindro',
    editable:true,
  },
  {
    title: 'Esf. Lejos',
    dataIndex: 'esfLejos',
    key: 'esfLejos',
  },
  {
    title: 'Esf. Cerca',
    dataIndex: 'esfCerca',
    key: 'esfCerca',
  },
  {
    title: 'Adicion',
    dataIndex: 'adicion',
    key: 'adicion',
  },
  {
    title: 'AVCC',
    dataIndex: 'avcc',
    key: 'avcc',
  },
];

const columnsPrescription = [
  {
    title: 'Ojo',
    dataIndex: 'ojo',
    key: 'ojo',
    className: 'borderedColumn',
  },
  {
    title: 'Eje',
    dataIndex: 'eje',
    key: 'eje',
  },
  {
    title: 'Cilindro',
    dataIndex: 'cilindro',
    key: 'cilindro',
  },
  {
    title: 'Esf. Lejos',
    dataIndex: 'esfLejos',
    key: 'esfLejos',
  },
  {
    title: 'Esf. Cerca',
    dataIndex: 'esfCerca',
    key: 'esfCerca',
  },
  {
    title: 'Esf. Media',
    dataIndex: 'esfMedia',
    key: 'esfMedia',
  },
  {
    title: 'Adicion',
    dataIndex: 'adicion',
    key: 'adicion',
  },
];

const columnsVisualSharp= [
  {
    title: 'Ojo',
    dataIndex: 'ojo',
    key: 'ojo',
    className: 'borderedColumn',
  },
  {
    title: 'SC',
    dataIndex: 'sc',
    key: 'sc',
  },
  {
    title: 'CC',
    dataIndex: 'cc',
    key: 'cc',
  },
  {
    title: 'Cerca',
    dataIndex: 'cerca',
    key: 'cerca',
    className: 'borderedColumn',
  },
  {
    title: 'A.V.Binocular',
    dataIndex: 'visualSharpBino',
    key: 'visualSharpBino',
    render: (value:any, row:any, index:number) => {
      const obj = {
        children: value,
        props: {} as any,
      };
      // These two are merged into above cell
      if (index === 0) {
        obj.props.rowSpan = 2;
      }
       if (index === 1) {
         obj.props.colSpan = 0;
       }
      return obj;
    },
  },
];

const columnsDistance = [
  {
    title: 'Ojo',
    dataIndex: 'ojo',
    key: 'ojo',
    className: 'borderedColumn',
  },
  {
    title: 'DNP L',
    dataIndex: 'dnpl',
    key: 'dnpl',
  },
  {
    title: 'DNP C',
    dataIndex: 'dnpc',
    key: 'dnpc',
  },

];

const prescriptors = [
  {
    name: 'Fernando Jimenez Gil',
    ocupation: 'Óptico',
    imgSrc: '',
  },
  {
    name: 'Faina Hassuf Pelayo',
    ocupation: 'Óptico',
    imgSrc: 'img/pacientes/Female.svg',
  },
];




export {columnsRx, columnsPrescription, columnsVisualSharp, columnsDistance, prescriptors}
